import { type FC } from 'react';
import type { RgbaColor } from '~/_shared/components/colorPicker/colorPicker.types';
import {
  colorTileStyle, outlineStyles, placeholderStyle,
} from './tinyMapColorTile.styles';
import {
  TinyMapPlaceholderComponent, type TinyMapPlaceholderComponentProps, type TinyMapPlaceholderShape,
} from './tinyMapPlaceholder.component';

export type TinyMapColorTileComponentProps = {
  color: RgbaColor;
  lineColor?: RgbaColor;
  lineWidth?: number;
  fill?: boolean;
  shape?: TinyMapPlaceholderShape;
  outline?: boolean;
} & Pick<TinyMapPlaceholderComponentProps, 'className' | 'size'>;

export const TinyMapColorTileComponent: FC<TinyMapColorTileComponentProps> = ({
  className,
  lineWidth = 0,
  outline,
  shape,
  size,
  ...restProps
}) => (
  <TinyMapPlaceholderComponent
    className={className}
    css={placeholderStyle(shape)}
    shape={shape}
    size={size}
  >
    <div css={colorTileStyle({ lineWidth, shape, ...restProps })} />
    {outline && (<div css={outlineStyles({ lineWidth, shape, ...restProps })} />)}
  </TinyMapPlaceholderComponent>
);
